import createIsAsyncValidating from './selectors/isAsyncValidating';
import plain from './structure/plain';

export default createIsAsyncValidating(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/isAsyncValidating.js
// module id = 4269
// module chunks = 25